<template>
    <b-row
      v-if="attachmentId || true"
      class="border rounded mx-0 mt-4 py-3"
    >
      <b-col cols="12" class="text-center">
        <b-alert v-if="successfullyUpload" variant="success" show>
          <strong v-text="$lang.message_image_login_successfully" />
        </b-alert>
        <b-alert v-else variant="info" show v-text="$lang.message_image_login" />
      </b-col>
      <b-col cols="12" v-if="!successfullyUpload">
        <b-row align-v="center" align-h="center">
          <b-col class="text-center" cols="12" md="5">
            <singleUploadLogin :data="itemsUpload" @done="successfullyUpload=true" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
</template>
<script>
  import singleUploadLogin from "@/components/base/singleUploadLogin"

export default {
    components: {
        singleUploadLogin
    },
    props: {
        attachmentId: {
            type: [String, Number],
            default: ""
        }
    },
    data() {
        return {
            successfullyUpload: false
        }
    }
}
</script>